'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoIssueClosed = function GoIssueClosed(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 12.3l-3.7 3.8 6.2 6.4 10-10-3.7-3.7-6.2 6.2-2.6-2.7z m-7.5 20.2c-6.9 0-12.5-5.6-12.5-12.5 0-6.9 5.6-12.5 12.5-12.5 3.5 0 6.6 1.4 8.8 3.7l3.6-3.6c-3.2-3.1-7.6-5.1-12.4-5.1-9.7 0-17.5 7.8-17.5 17.5s7.8 17.5 17.5 17.5c9.7 0 17.5-7.8 17.5-17.5l-7.8 7.8c0.3-0.4-2.9 4.7-9.7 4.7z m2.5-22.5h-5v12.5h5v-12.5z m-5 20h5v-5h-5v5z' })
        )
    );
};

exports.default = GoIssueClosed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/issue-closed.js
// module id = 2187
// module chunks = 168707334958949